import React from 'react';
import { useParams } from 'react-router-dom';
import articles from '../articles';
import NotFound from './NotFound';

const ArticleRenderer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) return <NotFound />;

  let entry = (articles as any)[id];

  // If not found by key, try to find by meta.id (some articles expose meta.id)
  if (!entry) {
    const keys = Object.keys(articles);
    for (const k of keys) {
      const e = (articles as any)[k];
      const metaId = e && e.meta && (e.meta.id ? String(e.meta.id) : undefined);
      if (metaId === id) {
        entry = e;
        break;
      }
    }
  }

  if (!entry) return <NotFound />;

  // articles/index.ts exports entries in the shape { Component, meta }
  const Comp = entry.Component ? entry.Component : entry;

  return (
    <div className="bg-[var(--color-bg-primary)] py-[8rem] min-h-screen transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
      <div className="container mx-auto px-6 max-w-6xl">
        <Comp />
      </div>
    </div>
  );
};

export default ArticleRenderer;
